import { envConfig } from "@configs/env";
import { getBrandResource } from "@utils/misc";
import { cn, PropsWithClassName } from "kz-ui-sdk";
import { useState } from "react";

interface BrandBannerProps extends PropsWithClassName {}

const BrandBanner = ({ className }: BrandBannerProps) => {
  const [isError, setIsError] = useState(false);

  const handleError = () => {
    setIsError(true);
  };

  if (isError) {
    return (
      <div
        className={cn(
          "relative w-full rounded-lg border border-white/10 bg-darkBrand-900 text-base font-bold leading-5",
          className,
        )}
      >
        <div className="relative items-center pt-[31.5%] text-darkBrand-100">
          <span className="absolute left-0 top-0 flex h-full w-full items-center justify-center text-2xl">
            {envConfig.brand.name}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "relative w-full rounded-lg border border-white/10 bg-darkBrand-900 text-base font-bold leading-5",
        className,
      )}
    >
      <div className="relative pt-[31.5%]">
        <picture
          className="absolute inset-0 z-[1] h-full w-full rounded-lg border-hidden"
          onError={handleError}
        >
          <source
            type="image/webp"
            srcSet={getBrandResource("main_banner.webp")}
          />
          <img
            className="h-full w-full rounded-lg border-hidden object-cover object-center"
            src={getBrandResource("main_banner.png")}
            alt="main-banner"
            aria-label="Main banner"
          />
        </picture>
      </div>
    </div>
  );
};

export default BrandBanner;
